export var getSimpleTitle = function getSimpleTitle(title) {
  if (!title) return;
  return title.replace(/<[/]?font.*?>/g, "");
};